<div mat-dialog-title class="dialog-title p-3 pr-5" *ngIf="!incidentTabsComponent">
  <h5>Incident</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<ng-container *ngIf="!incidentTabsComponent else tabs">

    <form #f="ngForm" (ngSubmit)="onSubmit(f)">

      <hr class="m-0 p-0">

      <mat-dialog-content class="px-3 py-4">

        <div class="row" *ngIf="incident.id">
          <div class="col">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="incident.id">
              <mat-label>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}</mat-label>
              <input placeholder="{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}" [value]="incident.site.name + ' - ' + incident.site.location"
                matTooltip="Where did this Incident occur?" disabled matInput />
                <mat-hint>The address the incident took place at.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">

            <div class="row" *ngIf="incident.id">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Reported By</mat-label>
                  <input placeholder="Reported By"
                         [value]="incident?.created_by_user?.contact_person"
                         matTooltip="Who created the Incident?" disabled matInput />
                  <mat-hint>The person that reported the incident.</mat-hint>
                </mat-form-field>
              </div>

              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Reported At</mat-label>
                  <input placeholder="Reported At"
                         [value]="incident?.date_created * 1000 | timezoneConvertLong"
                         matTooltip="When was this Incident reported?" disabled matInput />
                  <mat-hint>When the incident took place.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <app-datetime-picker
                  [selectedDateTime]="incidentDateTime"
                  [isRequired]="true"
                  [pickerName]="'incidentDateTime'"
                  [label]="'Date of Incident'"
                  [hint]="'When did the incident occur?'"
                  [selectTooltip]="'Select the date.'"
                  [removeTooltip]="'Remove the date.'"
                  [errorText]="'Please select a date.'"
                  [classes]="'full-width mb-4'"
                  (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
              </div>
              <div class="col-12 col-xl-6">
                <app-timezone-select *ngIf="!incident.id" [timezoneInput]="selectedTimezone" (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>
              </div>
            </div>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Summary of Incident</mat-label>
              <textarea matInput placeholder="Summary of Incident"
                [(ngModel)]="incident.details" name="details" #details rows="5"
                required matTooltip="What happened specifically?">
              </textarea>
              <mat-hint>Please enter a general summary of the incident.</mat-hint>
            </mat-form-field>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>What type of treatment was required?</mat-label>
                  <mat-select placeholder="What type of treatment was required?" [(ngModel)]="incident.treatment" name="treatment" matInput>
                    <mat-option value="No Treatment">No Treatment</mat-option>
                    <mat-option value="Medical Treatment">Medical Treatment</mat-option>
                    <mat-option value="First Aid">First Aid</mat-option>
                    <mat-option value="Hospitalisation">Hospitalisation</mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of treatment was required.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Type of Incident</mat-label>
                  <mat-select placeholder="Type of Incident" [(ngModel)]="incident.type"
                              name="type" matInput required #type>
                    <mat-option *ngFor="let incident_type of incident_types" [value]="incident_type">{{incident_type}}</mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of incident took place.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field *ngIf="utils.incidentTypeShowsIllnessDetails(incident.type)" class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Illness Type</mat-label>
                  <mat-select placeholder="Illness Type" [(ngModel)]="incident.illness_type"
                              name="illness_type" matInput [required]="utils.incidentTypeRequiresIllnessDetails(incident.type)" #illnessType>
                    <mat-option *ngFor="let illness of illness_types" [value]="illness">
                      {{illness}}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of illness it is.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field *ngIf="utils.incidentTypeShowsInjuryDetails(incident.type)" class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Injury Type</mat-label>
                  <mat-select placeholder="Injury Type" [(ngModel)]="incident.injury_type"
                              name="injury_type" matInput [required]="utils.incidentTypeRequiresInjuryDetails(incident.type)" #injuryType>
                    <mat-option *ngFor="let injury of injury_types" [value]="injury">
                      {{injury}}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of injury it is.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field *ngIf="utils.incidentTypeShowsInjuryDetails(incident.type)" class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Body Parts</mat-label>
                  <mat-select placeholder="Body Parts" [(ngModel)]="incidentBodyParts"
                              multiple name="body_parts" matInput>
                    <mat-option *ngFor="let part of body_parts" [value]="part">
                      {{part}}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Please select one or more affected body parts.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Who was Involved?</mat-label>
                  <mat-select placeholder="Who was Involved?" [(ngModel)]="incident.who_was_involved_selections"
                              name="who_was_involved" matInput #whoWasInvolved multiple>
                    <mat-option *ngFor="let who_was_involved_option of who_was_involved_options" [value]="who_was_involved_option">{{who_was_involved_option}}</mat-option>
                  </mat-select>
                  <mat-hint>Please select who was involved with the incident.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Drug and Alcohol Testing Required?</mat-label>
                  <mat-select placeholder="Drug and Alcohol Testing Required?"
                              [(ngModel)]="incident.drug_testing_required" name="drug_testing"
                              matInput required #drugTesting
                              matTooltip="Should the affected users be tested?">
                    <mat-option></mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                  <mat-hint>Please select Yes if drug and alcohol testing is required.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>{{ utils.getLangTerm('incidents.form.worksafe_notification', 'Does this incident require a WorkSafe notification?') }}</mat-label>
                  <mat-select
                    [placeholder]="utils.getLangTerm('incidents.form.worksafe_notification', 'Does this incident require a WorkSafe notification?')"
                    [(ngModel)]="incident.worksafe_notification" name="worksafe-required"
                    matInput>
                    <mat-option [value]="1">Yes</mat-option>
                    <mat-option [value]="0">No</mat-option>
                  </mat-select>
                  <mat-hint>{{ utils.getLangTerm('incidents.form.worksafe_notification_hint', 'Please select Yes if a WorkSafe notification is required.') }}</mat-hint>
                </mat-form-field>
              </div>
            </div>

          </div>

          <div class="col">

            <div class="row">
              <div class="col-12 col-xl-6">
                <ng-container *ngIf="incident.id else cannotChangeStatus">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Please select the status of the incident</mat-label>
                    <mat-select placeholder="Please select the status of the incident" [(ngModel)]="incident.status" name="status" matInput>
                      <mat-option *ngFor="let status of statuses" [value]="status">{{ status }}</mat-option>
                    </mat-select>
                    <mat-hint>Please select the status of the incident.</mat-hint>
                  </mat-form-field>
                </ng-container>
                <ng-template #cannotChangeStatus>
                  <p><strong>Status:</strong> {{ incident.status }}</p>
                </ng-template>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Does the incident require an investigation?</mat-label>
                  <mat-select placeholder="Does the incident require an investigation?"
                              [(ngModel)]="incident.requires_investigation"
                              name="requires-investigation" matInput>
                    <mat-option [value]="1">Yes</mat-option>
                    <mat-option [value]="0">No</mat-option>
                  </mat-select>
                  <mat-hint>Please select Yes if an investigation is required.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <mat-form-field *ngIf="!incident.requires_investigation" class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Provide a reason for not investigating this incident</mat-label>
              <textarea matInput
                placeholder="Provide a reason for not investigating this incident"
                [(ngModel)]="incident.no_investigation_reason"
                name="no-investigation-reason" #noInvestigationReason rows="5"
                matTooltip="Why won't this Incident be investigated?">
              </textarea>
              <mat-error *ngIf="!noInvestigationReason.valid">
                Please provide a reason for not investigating this incident.
              </mat-error>
            </mat-form-field>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Is this a Lost Time Injury?</mat-label>
                  <mat-select placeholder="Is this a Lost Time Injury?" [(ngModel)]="incident.is_lti" name="is_lti" matInput>
                    <mat-option [value]="1">Yes</mat-option>
                    <mat-option [value]="0">No</mat-option>
                  </mat-select>
                  <mat-hint>Please select Yes if this is a Lost Time Injury.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field *ngIf="incident.is_lti == true" class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Estimated LTI Days</mat-label>
                  <input matInput placeholder="Estimated LTI Days" [(ngModel)]="incident.estimated_lti_days"
                         name="estimated_lti_days" type="number" [required]="incident.is_lti == true" #estimated_lti_days matTooltip="How many days do you estimate for this LTI?" />
                  <mat-hint>Please enter your estimated LTI days here. You can use 0.5 to indicate half a day.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="alert alert-info mb-4" role="alert" *ngIf="incident.is_lti == true">
              Actual Calculated LTI: {{ incident.actual_lti_days }} day{{ incident.actual_lti_days != 1 ? 's' : '' }}.
            </div>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Incident Causal Analysis Findings</mat-label>
              <textarea matInput placeholder="Incident Causal Analysis Findings"
              [(ngModel)]="incident.casual_analysis_findings" name="casual_analysis_findings" #casual_analysis_findings
              rows="5" matTooltip="Incident causal analysis findings & how and why did this incident happen.">
              </textarea>
              <mat-hint>Incident causal analysis findings & how and why did this incident happen.</mat-hint>
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Location</mat-label>
              <textarea
                matInput
                placeholder="Location"
                [(ngModel)]="incident.location"
                name="location"
                #location
                rows="5"
                matTooltip="Please enter the incident location here.">
              </textarea>
              <mat-hint>Please enter the incident location here.</mat-hint>
            </mat-form-field>

          </div>
        </div>

      </mat-dialog-content>

      <hr class="m-0 p-0">

      <mat-dialog-actions class="p-3">

        <mat-error class="my-2 mx-1" *ngIf="!incident.site_id">Please select a {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}.</mat-error>

        <div class="w-100" *ngIf="!incident.site_id"></div>

        <!-- Hidden when the user cannot perform the action (create for a new incident, edit for an
             existing one). Remains disabled only for form validity and in-flight state. -->
        <button
          *ngIf="incident.id ? canEdit : canCreate"
          mat-raised-button
          type="button"
          color="primary"
          class="my-2 ml-1 mr-2"
          matTooltip="Save the Incident"
          [disabled]="!f.valid || !incident.site_id || inProgress"
          (click)="onSubmit(f)">
          <mat-icon>save</mat-icon>
          Save
        </button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          (click)="onSelectSites()"
          *ngIf="!incident.id"
          matTooltip="Where did this happen?">
          <mat-icon>location_on</mat-icon>
          Select {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} * ({{ incident.site_id ? '1' : '0' }})
        </button>

        <app-file-browse-button
          (selectedFiles)="onSelectFiles($event)"
          (afterDialogClosedEvent)="onSubmit(f)"
          parentObjectType="incident"
          [parentObjectId]="incident.id"
          [filesCount]="incident.files.length">
        </app-file-browse-button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          [matBadge]="'' + (incident?.user_ids?.length)"
          (click)="onSelectUsers()"
          matTooltip="Who was impacted by this Incident?">
          <mat-icon>people</mat-icon>
          Affected Users
        </button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          *ngIf="incident.site_id && incident.site_id > 0"
          (click)="selectAssets()"
          [matBadge]="'' + (incident.asset_ids ? incident.asset_ids?.length : 0)"
          matTooltip="Select Assets from the Assets selection list.">
          <mat-icon>forklift</mat-icon>
          Assets
        </button>

        <button
          mat-raised-button
          *ngIf="canViewAccountTags"
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          (click)="selectTags()"
          [matBadge]="'' + (incident.tag_ids ? incident.tag_ids?.length : 0)"
          matTooltip="Select Tags from the Tags selection list.">
          <mat-icon> local_offer</mat-icon>
          Tags
        </button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          (click)="onCancel()"
          *ngIf="dialogData">
          <mat-icon>close</mat-icon>
          Cancel
        </button>

        <button
          mat-icon-button
          type="button"
          color="warn"
          class="dialog-remove-button my-2 ml-auto mr-1"
          (click)="onRemove()"
          *ngIf="incident.id && canDelete"
          matTooltip="Delete this Incident">
          <mat-icon>delete</mat-icon>
        </button>

      </mat-dialog-actions>

    </form>

</ng-container>

<ng-template #tabs>
  <form #f="ngForm" (ngSubmit)="onSubmit(f)">
    <div class="container-fluid p-0">

      <div class="px-3 py-4">

        <div class="row">
          <div class="col">
            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="incident.id">
              <mat-label>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}</mat-label>
              <input placeholder="{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}" [value]="incident.site.name + ' - ' + incident.site.location"
                     matTooltip="Where did this Incident occur?" disabled matInput />
              <mat-hint>The address the incident took place at.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="incident.id">
                  <mat-label>Reported By</mat-label>
                  <input placeholder="Reported By"
                         [value]="incident?.created_by_user?.contact_person"
                         matTooltip="Who created the Incident?" disabled matInput />
                  <mat-hint>The person that reported the incident.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="incident.id">
                  <mat-label>Reported At</mat-label>
                  <input placeholder="Reported At"
                         [value]="incident?.date_created * 1000 | timezoneConvertLong"
                         matTooltip="When was this Incident reported?" disabled matInput />
                  <mat-hint>When the incident took place.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <app-datetime-picker
                  [selectedDateTime]="incidentDateTime"
                  [isRequired]="true"
                  [pickerName]="'incidentDateTime'"
                  [label]="'Date of Incident'"
                  [hint]="'When did the incident occur?'"
                  [selectTooltip]="'Select the date.'"
                  [removeTooltip]="'Remove the date.'"
                  [errorText]="'Please select a date.'"
                  [classes]="'full-width mb-4'"
                  (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
              </div>
              <div class="col-12 col-xl-6">
                <app-timezone-select *ngIf="!incident.id" [timezoneInput]="selectedTimezone" (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>
              </div>
            </div>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Summary of Incident</mat-label>
              <textarea matInput placeholder="Summary of Incident"
                        [(ngModel)]="incident.details" name="details" #details rows="5"
                        required matTooltip="What happened specifically?">
              </textarea>
              <mat-hint>Please enter a general summary of the incident.</mat-hint>
            </mat-form-field>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>What type of treatment was required?</mat-label>
                  <mat-select placeholder="What type of treatment was required?" [(ngModel)]="incident.treatment" name="treatment" matInput>
                    <mat-option value="No Treatment">No Treatment</mat-option>
                    <mat-option value="Medical Treatment">Medical Treatment</mat-option>
                    <mat-option value="First Aid">First Aid</mat-option>
                    <mat-option value="Hospitalisation">Hospitalisation</mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of treatment was required.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Type of Incident</mat-label>
                  <mat-select placeholder="Type of Incident" [(ngModel)]="incident.type"
                              name="type" matInput required #type>
                    <mat-option *ngFor="let incident_type of incident_types" [value]="incident_type">{{incident_type}}</mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of incident took place.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="utils.incidentTypeShowsIllnessDetails(incident.type)">
                  <mat-label>Illness Type</mat-label>
                  <mat-select placeholder="Illness Type" [(ngModel)]="incident.illness_type"
                              name="illness_type" matInput [required]="utils.incidentTypeRequiresIllnessDetails(incident.type)" #illnessType>
                    <mat-option *ngFor="let illness of illness_types" [value]="illness">
                      {{illness}}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of illness it is.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="utils.incidentTypeShowsInjuryDetails(incident.type)">
                  <mat-label>Injury Type</mat-label>
                  <mat-select placeholder="Injury Type" [(ngModel)]="incident.injury_type"
                              name="injury_type" matInput [required]="utils.incidentTypeRequiresInjuryDetails(incident.type)" #injuryType>
                    <mat-option *ngFor="let injury of injury_types" [value]="injury">
                      {{injury}}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Please select what type of injury it is.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="utils.incidentTypeShowsInjuryDetails(incident.type)">
                  <mat-label>Body Parts</mat-label>
                  <mat-select placeholder="Body Parts" [(ngModel)]="incidentBodyParts"
                              multiple name="body_parts" matInput>
                    <mat-option *ngFor="let part of body_parts" [value]="part">
                      {{part}}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Please select one or more affected body parts.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Who was Involved?</mat-label>
                  <mat-select placeholder="Who was Involved?" [(ngModel)]="incident.who_was_involved_selections"
                              name="who_was_involved" matInput #whoWasInvolved multiple>
                    <mat-option *ngFor="let who_was_involved_option of who_was_involved_options" [value]="who_was_involved_option">{{who_was_involved_option}}</mat-option>
                  </mat-select>
                  <mat-hint>Please select who was involved with the incident.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Drug and Alcohol Testing Required?</mat-label>
                  <mat-select placeholder="Drug and Alcohol Testing Required?"
                              [(ngModel)]="incident.drug_testing_required" name="drug_testing"
                              matInput required #drugTesting
                              matTooltip="Should the affected users be tested?">
                    <mat-option></mat-option>
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                  <mat-hint>Please select Yes if drug and alcohol testing is required.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>{{ utils.getLangTerm('incidents.form.worksafe_notification', 'Does this incident require a WorkSafe notification?') }}</mat-label>
                  <mat-select
                    [placeholder]="utils.getLangTerm('incidents.form.worksafe_notification', 'Does this incident require a WorkSafe notification?')"
                    [(ngModel)]="incident.worksafe_notification" name="worksafe-required"
                    matInput>
                    <mat-option [value]="1">Yes</mat-option>
                    <mat-option [value]="0">No</mat-option>
                  </mat-select>
                  <mat-hint>{{ utils.getLangTerm('incidents.form.worksafe_notification_hint', 'Please select Yes if a WorkSafe notification is required.') }}</mat-hint>
                </mat-form-field>
              </div>
            </div>

          </div>

          <div class="col">

            <div class="row">
              <div class="col-12 col-xl-6">
                <ng-container *ngIf="incident.id else cannotChangeStatus">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Please select the status of the incident</mat-label>
                    <mat-select placeholder="Please select the status of the incident" [(ngModel)]="incident.status" name="status" matInput>
                      <mat-option *ngFor="let status of statuses" [value]="status">{{ status }}</mat-option>
                    </mat-select>
                    <mat-hint>Please select the status of the incident.</mat-hint>
                  </mat-form-field>
                </ng-container>
                <ng-template #cannotChangeStatus>
                  <p><strong>Status:</strong> {{ incident.status }}</p>
                </ng-template>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Does the incident require an investigation?</mat-label>
                  <mat-select placeholder="Does the incident require an investigation?"
                              [(ngModel)]="incident.requires_investigation"
                              name="requires-investigation" matInput>
                    <mat-option [value]="1">Yes</mat-option>
                    <mat-option [value]="0">No</mat-option>
                  </mat-select>
                  <mat-hint>Please select Yes if an investigation is required.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="!incident.requires_investigation">
              <mat-label>Provide a reason for not investigating this incident</mat-label>
              <textarea matInput
                        placeholder="Provide a reason for not investigating this incident"
                        [(ngModel)]="incident.no_investigation_reason"
                        name="no-investigation-reason" #noInvestigationReason rows="5"
                        matTooltip="Why won't this Incident be investigated?">
              </textarea>
              <mat-error *ngIf="!noInvestigationReason.valid">
                Please provide a reason for not investigating this incident.
              </mat-error>
            </mat-form-field>

            <div class="row">
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Is this a Lost Time Injury?</mat-label>
                  <mat-select placeholder="Is this a Lost Time Injury?" [(ngModel)]="incident.is_lti" name="is_lti" matInput>
                    <mat-option [value]="1">Yes</mat-option>
                    <mat-option [value]="0">No</mat-option>
                  </mat-select>
                  <mat-hint>Please select Yes if this is a Lost Time Injury.</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-xl-6">
                <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="incident.is_lti == true">
                  <mat-label>Estimated LTI Days</mat-label>
                  <input matInput placeholder="Estimated LTI Days" [(ngModel)]="incident.estimated_lti_days"
                         name="estimated_lti_days" type="number" [required]="incident.is_lti == true" #estimated_lti_days matTooltip="How many days do you estimate for this LTI?" />
                  <mat-hint>Please enter your estimated LTI days here. You can use 0.5 to indicate half a day.</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="alert alert-info mb-4" role="alert" *ngIf="incident.is_lti == true">
              Actual Calculated LTI: {{ incident.actual_lti_days }} day{{ incident.actual_lti_days != 1 ? 's' : '' }}.
            </div>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Causal Analysis Findings</mat-label>
              <textarea matInput placeholder="Causal Analysis Findings"
                        [(ngModel)]="incident.casual_analysis_findings" name="casual_analysis_findings" #casual_analysis_findings
                        rows="5" matTooltip="Please enter your causal analysis findings here.">
              </textarea>
              <mat-hint>Please enter your causal analysis findings here.</mat-hint>
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Location</mat-label>
              <textarea
                matInput
                placeholder="Location"
                [(ngModel)]="incident.location"
                name="location"
                #location
                rows="5"
                matTooltip="Please enter the incident location here.">
              </textarea>
              <mat-hint>Please enter the incident location here.</mat-hint>
            </mat-form-field>

          </div>
        </div>

      </div>

      <hr class="m-0 p-0">

      <mat-dialog-actions class="p-3">

        <mat-error class="my-2 mx-1" *ngIf="!incident.site_id">Please select a {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}.</mat-error>

        <div class="w-100" *ngIf="!incident.site_id"></div>

        <!-- Hidden when the user cannot perform the action (create for a new incident, edit for an
             existing one). Remains disabled only for form validity and in-flight state. -->
        <button
          *ngIf="incident.id ? canEdit : canCreate"
          mat-raised-button
          type="button"
          color="primary"
          class="my-2 ml-1 mr-2"
          matTooltip="Save the Incident"
          [disabled]="!f.valid || !incident.site_id || inProgress"
          (click)="onSubmit(f)">
          <mat-icon>save</mat-icon>
          Save
        </button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          (click)="onSelectSites()"
          *ngIf="!incident.id"
          matTooltip="Where did this happen?">
          <mat-icon>location_on</mat-icon>
          Select {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} * ({{ incident.site_id ? '1' : '0' }})
        </button>

        <app-file-browse-button
          (selectedFiles)="onSelectFiles($event)"
          (afterDialogClosedEvent)="onSubmit(f)"
          parentObjectType="incident"
          [parentObjectId]="incident.id"
          [filesCount]="incident.files.length">
        </app-file-browse-button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          [matBadge]="'' + (incident?.user_ids?.length)"
          (click)="onSelectUsers()"
          matTooltip="Who was impacted by this Incident?">
          <mat-icon>people</mat-icon>
          Affected Users
        </button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          *ngIf="incident.site_id && incident.site_id > 0 && !incident.id"
          (click)="selectAssets()"
          [matBadge]="'' + (incident.asset_ids ? incident.asset_ids?.length : 0)"
          matTooltip="Select Assets from the Assets selection list.">
          <mat-icon>forklift</mat-icon>
          Assets
        </button>

        <button
          mat-raised-button
          *ngIf="canViewAccountTags"
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          (click)="selectTags()"
          [matBadge]="'' + (incident.tag_ids ? incident.tag_ids?.length : 0)"
          matTooltip="Select Tags from the Tags selection list.">
          <mat-icon>local_offer</mat-icon>
          Tags
        </button>

        <button
          mat-raised-button
          type="button"
          color="secondary"
          class="my-2 ml-1 mr-2"
          (click)="onCancel()"
          *ngIf="dialogData">
          <mat-icon>close</mat-icon>
          Cancel
        </button>

        <button
          mat-icon-button
          type="button"
          color="warn"
          class="dialog-remove-button my-2 ml-auto mr-1"
          (click)="onRemove()"
          *ngIf="incident.id && canDelete"
          matTooltip="Delete this Incident">
          <mat-icon>delete</mat-icon>
        </button>

      </mat-dialog-actions>

    </div>
  </form>
</ng-template>
